module.exports = __webpack_public_path__ + "fonts/NeutraText-Demi.591c1e12.otf";